import styled from 'styled-components'

// 👹 Please forgive me!!! 😭
export const StyledDynamicMap = styled.div`
  height: 100%;

  .gm-style-iw-chr {
    height: 0 !important;
    z-index: 9999 !important;
  }

  .gm-style-iw.gm-style-iw-c {
    border-radius: 4px !important;
    padding: 0 !important;
    min-width: 13.75rem !important;
    max-height: none !important;
    max-width: 220px !important;
  }

  .gm-style-iw-d {
    overflow: hidden !important;
    padding: 0 !important;
    max-height: none !important;
  }

  .gm-style-iw-tc {
    display: none;
  }

  button.gm-ui-hover-effect {
    display: block !important;
    width: 2.5rem !important;
    height: 2.5rem !important;
    border-radius: 50% !important;

    position: absolute !important;
    top: 0.75rem !important;
    right: 0.75rem !important;

    background: white !important;

    opacity: 1;
  }

  button.gm-ui-hover-effect span {
    display: block !important;
    width: 1.25rem !important;
    height: 1.25rem !important;
    margin: 0 !important;

    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;

    -webkit-mask-size: contain !important;
    background: ${({ theme }) => theme.ColorThemeCtaSecondary} !important;
  }
`
